<template>
  <!--  -->
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 py-3 items-center">
    <!--  -->
    <div class="bg-white w-full rounded-lg shadow pb-20">
      <!--  -->
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <!--  -->
        <div class="flex w-full">
          <!--  -->
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <!--  -->
            <i class="material-icons">chevron_left</i>
            <!--  -->
          </button>
          <!--  -->

          <!--  -->
          <div class="text-xl font-bold text-primary-700">
            {{ $t('payement_details') }}
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="p-10">
        <!--  -->
        <div class="flex justify-between">
          <!--  -->
          <h2 class="text-2xl font-bold mb-6 pb-2 tracking-wider uppercase">
            Invoice
          </h2>
          <!--  -->

          <!--  -->
          <div class="relative inline-block">
            <!--  -->
            <div
              class="text-gray-900 cursor-pointer w-10 h-10 rounded-full bg-gray-300 hover:bg-gray-300 inline-flex items-center justify-center"
              @click="generateReport"
            >
              <!--  -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="icon icon-tabler icon-tabler-printer"
              >
                <!--  -->
                <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
                <!--  -->
                <path
                  d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
                ></path>
                <!--  -->
                <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"></path>
                <!--  -->
                <rect x="7" y="13" width="10" height="8" rx="2"></rect>
                <!--  -->
              </svg>
              <!--  -->
            </div>
            <!--  -->

            <!--  -->
            <div
              x-show.transition="showTooltip"
              class="z-40 shadow-lg text-center w-32 block absolute right-0 top-0 p-2 mt-12 rounded-lg bg-gray-800 text-white text-xs"
              style="display: none;"
            >
              Print this invoice!
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <section id="pdf-content" class="relative">
          <!--  -->
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <!--  -->

          <!--  -->
          <div class="flex pr-5 pl-5 space-x-3">
            <!--  -->
            <div class="flex justify-between w-full h-auto p-4 my-1 rounded-lg">
              <!--  -->
              <div class="flex w-full">
                <!--  -->
                <div class="ml-5 w-full space-y-2">
                  <!--  -->
                  <div class="text-base mt-2 mb-2 font-semibold text-gray-700">
                    {{ $t('payement_no') }} : <span>#{{ formData.id }}</span>
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="text-sm text-gray-600">
                    {{ $t('store') }} :
                    <span
                      v-if="this.formData.seller"
                      class="justify-center text-xs text-center p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                    >
                      {{ formData.seller.company }}
                    </span>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="text-sm text-gray-600">
                    {{ $t('payement_method') }} :
                    <span
                      class="justify-center text-xs text-center p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                    >
                      {{ formData.method }}
                    </span>
                    <!--  -->
                  </div>
                  <!--  -->

                  <!--  -->
                  <div class="text-sm text-gray-600">
                    <!--  -->
                    {{ $t('date_payement') }}:
                    <span
                      class="justify-center text-xs text-center p-1 pl-3 pr-2 w-auto font-semibold rounded-full text-gray-700"
                    >
                      {{ $moment(formData.date).format('yyyy-MM-DD hh:mm') }}
                    </span>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->

          <!--  -->
          <div class="flex pr-5 pl-5 mt-6">
            <!--  -->
            <div
              class="flex justify-between w-full h-auto p-4 rounded-lg border-gray-100 overflow-auto "
            >
              <!--  -->
              <div class="flex w-full">
                <!--  -->
                <div class="ml-1 w-full p-2">
                  <!--  -->
                  <div class="w-full mt-4">
                    <!--  -->
                    <table class="min-w-full leading-normal">
                      <!--  -->
                      <thead>
                        <!--  -->
                        <tr>
                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                          >
                            {{ $t('order_id') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                          >
                            {{ $t('city') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                          >
                            {{ $t('trackingnumber') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                          >
                            {{ $t('total_price') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <template
                            v-if="
                              formData.details.some(el => el.global_vat > 0)
                            "
                          >
                            <th
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(el => !el.global_vat)
                              "
                            >
                              {{ $t('global_fees') }}
                            </th>

                            <!--  -->
                            <th
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.confirmation_vat,
                                  )
                              "
                            >
                              {{ $t('confirmation_fees') }}
                            </th>
                            <!--  -->
                          </template>
                          <!--  -->

                          <!--  -->
                          <template v-else>
                            <!--  -->
                            <th
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.confirmation_vat,
                                  )
                              "
                            >
                              {{ $t('confirmation_fees') }}
                            </th>
                            <!--  -->

                            <!--  -->
                            <th
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.fulfillement_fees_vat,
                                  )
                              "
                            >
                              {{ $t('fulfillement_fees') }}
                            </th>
                            <!--  -->

                            <!--  -->
                            <th
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                            >
                              {{ $t('shipping_fees') }}
                            </th>
                            <!--  -->

                            <!--  -->
                            <th
                              v-if="
                                formData.details[0] &&
                                  formData.details[0].shipping_refund_vat
                              "
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                            >
                              {{ $t('refund_fees') }}
                            </th>
                            <!--  -->

                            <!--  -->
                            <th
                              v-if="
                                formData.details[0] &&
                                  formData.details[0].shipping_cancel_vat
                              "
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                            >
                              {{ $t('cancellation_fees') }}
                            </th>
                            <!--  -->

                            <!--  -->
                            <th
                              class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.quality_control,
                                  )
                              "
                            >
                              {{ $t('quality_control') }}
                            </th>
                            <!--  -->
                          </template>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-primary-700 capitalize tracking-wider"
                          >
                            {{ $t('total') }}
                          </th>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </thead>
                      <!--  -->

                      <!--  -->
                      <tbody
                        v-for="(item, index) in formData.details"
                        :key="item._id"
                      >
                        <!--  -->
                        <tr :class="index % 2 == 0 ? 'bg-gray-100' : ''">
                          <!--  -->
                          <td
                            class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                          >
                            <!--  -->
                            <p class="text-gray-700 ml-6 whitespace-no-wrap">
                              <!--  -->
                              <span class="font-semibold">{{
                                item.order.id
                              }}</span>
                              <!--  -->
                            </p>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                          >
                            <!--  -->
                            <p class="text-gray-700 ml-6 whitespace-no-wrap">
                              <!--  -->
                              <span class="font-semibold"
                                >{{ item.order.customer.city }}
                                <!--  -->
                              </span>
                              <!--  -->
                            </p>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                          >
                            <!--  -->
                            <p class="text-gray-700 ml-6 whitespace-no-wrap">
                              <!--  -->
                              <span class="font-semibold">{{
                                item.order.trackingNumber || ''
                              }}</span>
                              <!--  -->
                            </p>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                          >
                            <!--  -->
                            <p class="text-gray-700 ml-6 whitespace-no-wrap">
                              <!--  -->
                              <span class="font-semibold">{{
                                (Math.sign(item.amount) == -1 &&
                                  !item.status) ||
                                (item.status && item.status !== 'delivered')
                                  ? 0
                                  : item.order.totalPrice
                              }}</span>
                              <!--  -->
                            </p>
                            <!--  -->
                          </td>
                          <!--  -->

                          <template v-if="item.global_vat > 0">
                            <!--  -->
                            <td
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.confirmation_vat,
                                  )
                              "
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.global_vat
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.confirmation_vat,
                                  )
                              "
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.confirmation_vat
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->
                          </template>

                          <!--  -->
                          <template v-else>
                            <!--  -->
                            <td
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.confirmation_vat,
                                  )
                              "
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.confirmation_vat
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.fulfillement_fees_vat,
                                  )
                              "
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.fulfillement_fees_vat
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.shipping_vat
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              v-if="!item.shipping_refund_vat == 0"
                              :class="
                                item.shipping_refund_vat == 0 ? 'empty-row' : ''
                              "
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.shipping_refund_vat == 0
                                    ? ''
                                    : item.shipping_refund_vat
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              v-if="!item.shipping_cancel_vat == 0"
                              :class="
                                item.shipping_cancel_vat == 0 ? 'empty-row' : ''
                              "
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.shipping_cancel_vat == 0
                                    ? ''
                                    : item.shipping_cancel_vat
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->

                            <!--  -->
                            <td
                              v-if="
                                formData.details.length !==
                                  formData.details.filter(
                                    el => !el.quality_control,
                                  )
                              "
                              class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                            >
                              <!--  -->
                              <p class="text-gray-700 ml-6 whitespace-no-wrap">
                                <!--  -->
                                <span class="font-semibold">{{
                                  item.quality_control == 0
                                    ? ''
                                    : item.quality_control
                                }}</span>
                                <!--  -->
                              </p>
                              <!--  -->
                            </td>
                            <!--  -->
                          </template>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-5 py-2 border-b border-gray-200 text-center  bg-white text-xs"
                          >
                            <!--  -->
                            <p class="text-gray-700 ml-6 whitespace-no-wrap">
                              <!--  -->
                              <span class="font-semibold"
                                >{{ item.amount }}
                                <!--  -->
                              </span>
                              <!--  -->
                            </p>
                            <!--  -->
                          </td>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </tbody>
                      <!--  -->
                    </table>
                    <!--  -->

                    <!--  -->
                    <table v-if="expeditionCount > 0" class="min-w-full">
                      <!--  -->
                      <thead>
                        <!--  -->
                        <tr>
                          <!--  -->
                          <th
                            :colspan="7"
                            class="text-center bg-gray-200 px-6 py-3 border-b-2 border-t-2 border-gray-300 leading-4 text-gray-600 tracking-wider"
                          >
                            <!--  -->
                            Expeditions
                            <!--  -->
                          </th>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </thead>
                      <!--  -->
                      <thead>
                        <!--  -->
                        <tr>
                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t('ID') }}
                            <!--  -->
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t('nb_packages') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t('transport_mode') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t('details') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t('country') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t('expedition_fees') }}
                          </th>
                          <!--  -->

                          <!--  -->
                          <th
                            class="px-5 py-3 text-center  border-b-2 border-gray-200 text-xs font-semibold text-gray-600 capitalize tracking-wider"
                          >
                            {{ $t('Package Fees') }}
                          </th>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </thead>
                      <!--  -->

                      <!--  -->
                      <tbody class="bg-white">
                        <!--  -->
                        <tr
                          v-for="(exp, ind) in formData.expeditions"
                          :key="ind"
                        >
                          <!--  -->
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b-2 text-center"
                          >
                            <!--  -->
                            <div
                              class="text-sm leading-5 text-orange-900 capitalize "
                            >
                              {{ exp.id.id }}
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b-2 text-center"
                          >
                            <!--  -->
                            <div
                              class="text-sm leading-5 text-orange-900 capitalize "
                            >
                              {{ exp.id.numberOfPackages }}
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b-2 text-center"
                          >
                            <!--  -->
                            <div
                              class="text-sm leading-5 text-orange-900 capitalize "
                            >
                              {{ exp.id.transportMode }}
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b-2 text-center"
                          >
                            <!--  -->
                            <div
                              class="text-sm leading-5 text-orange-900 capitalize "
                            >
                              {{ exp.id.details.length }} {{ $t('products') }}
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b-2 text-center"
                          >
                            <!--  -->
                            <div
                              class="text-sm leading-5 text-orange-900 capitalize "
                            >
                              {{ exp.id.country }}
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b-2 text-center"
                          >
                            <!--  -->
                            <div
                              class="text-sm leading-5 font-bold text-orange-900 capitalize "
                            >
                              {{ exp.fees }}
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->

                          <!--  -->
                          <td
                            class="px-6 py-2 whitespace-no-wrap border-b-2 text-center"
                          >
                            <!--  -->
                            <div
                              class="text-sm leading-5 font-bold text-orange-900 capitalize "
                            >
                              {{ exp.packageFees }}
                            </div>
                            <!--  -->
                          </td>
                          <!--  -->
                        </tr>
                        <!--  -->
                      </tbody>
                      <!--  -->
                    </table>
                    <!--  -->

                    <!--  -->
                    <div class="py-2 ml-auto mt-5 w-full sm:w-2/4">
                      <!--  -->
                      <div class="flex justify-between mb-3">
                        <!--  -->
                        <div
                          class="text-gray-800 font-semibold text-right flex-1"
                        >
                          Total Sales:
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="text-right w-40">
                          <!--  -->
                          <div class="text-gray-800 font-medium">
                            {{ totalSales }}
                            <sup>{{ currency }}</sup>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <div class="flex justify-between mb-3">
                        <!--  -->
                        <div
                          class="text-gray-800 font-semibold text-right flex-1"
                        >
                          Total Fees:
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="text-right w-40">
                          <!--  -->
                          <div class="text-gray-800 font-medium">
                            {{ totalFees }} <sup>{{ currency }}</sup>
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <div
                        v-if="formData.tva"
                        class="flex justify-between mb-4"
                      >
                        <!--  -->
                        <div
                          class="text-sm text-gray-800 font-semibold text-right flex-1"
                        >
                          TVA ({{ formData.tva }}%)
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="text-right w-40">
                          <!--  -->
                          <div class="text-sm text-gray-800">
                            {{ formData.vatFees }}
                            <!--  -->
                            <sup>{{ currency }}</sup>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <div
                        v-if="formData.refunds.length > 0"
                        class="flex justify-between mb-4"
                      >
                        <!--  -->
                        <div
                          class="text-sm text-gray-800 font-semibold text-right flex-1"
                        >
                          <!--  -->
                          Remboursements
                          <!--  -->
                          <small
                            >({{ formData.refunds.length }} orders)
                            <!--  -->
                            <a
                              class="text-orange-600"
                              target="_blank"
                              :href="
                                '/shippings?country=' +
                                  formData.country +
                                  '&payment=' +
                                  formData._id
                              "
                            >
                              <!--  -->
                              <img
                                style="height: 20px;"
                                class="material-icons ml-1 cursor-pointer"
                                src="https://img.icons8.com/glyph-neue/64/000000/share-3.png"
                              />
                              <!--  -->
                            </a>
                            <!--  -->
                          </small>
                          <!--  -->
                        </div>
                        <!--  -->

                        <!--  -->
                        <div class="text-right w-40">
                          <!--  -->
                          <div class="text-sm text-gray-800">
                            <!--  -->
                            {{
                              formData.refunds
                                .map(item => item.fees)
                                .reduce((prev, curr) => prev + curr, 0)
                            }}
                            <!--  -->
                            <sup>{{ currency }}</sup>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <div
                        v-if="
                          formData.expeditions &&
                            formData.expeditions.length > 0
                        "
                        class="flex justify-between mb-4"
                      >
                        <!--  -->
                        <div
                          class="text-sm text-gray-800 font-semibold text-right flex-1"
                        >
                          <!--  -->
                          Expeditions Fees
                          <small
                            >({{
                              formData.expeditions.length
                            }}
                            expeditions)</small
                          >
                          <!--  -->
                        </div>
                        <!--  -->
                        <div class="text-right w-40">
                          <!--  -->
                          <div class="text-sm text-gray-800">
                            <!--  -->
                            {{
                              formData.expeditions
                                .map(
                                  item =>
                                    parseFloat(item.fees) +
                                    parseFloat(item.packageFees),
                                )
                                .reduce((prev, curr) => prev + curr, 0)
                            }}
                            <!--  -->
                            <sup>{{ currency }}</sup>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->

                      <!--  -->
                      <div class="py-2 border-t border-b">
                        <!--  -->
                        <div class="flex justify-between">
                          <!--  -->
                          <div class="text-xl text-gray-600 text-right flex-1">
                            Payment net:
                          </div>
                          <!--  -->
                          <div class="text-right w-40">
                            <!--  -->
                            <div class="text-xl text-gray-800 font-bold">
                              <!--  -->
                              {{ total }} <sup>{{ currency }}</sup>
                              <!--  -->
                            </div>
                            <!--  -->
                          </div>
                          <!--  -->
                        </div>
                        <!--  -->
                      </div>
                      <!--  -->
                    </div>
                    <!--  -->
                  </div>
                  <!--  -->
                </div>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
          </div>
          <!--  -->
        </section>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
import jsPDFInvoiceTemplate, {
  OutputType,
  jsPDF,
} from 'jspdf-invoice-template';
import image from '@/assets/storeinoship.png';

//or directly in browser
export default {
  name: 'Invoice',
  data() {
    return {
      formData: {
        details: [],
        refunds: [],
      },
      expeditionCount: 0,
      image: image,
      fullPage: false,
      loading: false,
      content: [],
      headers: [
        { title: this.$t('order_id') },
        { title: this.$t('total_price') },
        { title: this.$t('Tracking') },
        { title: this.$t('City') },
        { title: this.$t('refund') },
        { title: this.$t('cancellation') },
        { title: this.$t('shipping') },
        { title: this.$t('fulfillement') },
        { title: this.$t('Quality') },
        { title: this.$t('confirmation') },
        { title: this.$t('global fees') },
      ],
      total: 0,
      options: this.$countries,
      currency: '',
      totalFees: 0,
      totalSales: 0,
      currentUser: {},
    };
  },
  async mounted() {
    await this.getCurrency();
    if (this.$route.params.id) {
      this.loading = true;
      const data = await this.$server.get('payments', {
        id: this.$route.params.id,
      });

      this.formData = data.content;

      if (this.formData && this.formData.expeditions) {
        this.expeditionCount = this.formData.expeditions.length;
      } else {
        this.expeditionCount = 0;
      }

      this.getTotal(this.formData);

      if (this.formData.details[0] && this.formData.details[0]) {
        if (this.formData.details[0].confirmation_vat === 0) {
          this.headers.splice(
            this.headers.findIndex(
              item => item.title === this.$t('confirmation'),
            ),
            1,
          );
        }

        if (this.formData.details[0].fulfillement_fees_vat === 0) {
          this.headers.splice(
            this.headers.findIndex(
              item => item.title === this.$t('fulfillement'),
            ),
            1,
          );
        }

        if (this.formData.details[0].shipping_cancel_vat === 0) {
          this.headers.splice(
            this.headers.findIndex(
              item => item.title === this.$t('cancellation'),
            ),
            1,
          );
        }

        if (this.formData.details[0].shipping_refund_vat === 0) {
          this.headers.splice(
            this.headers.findIndex(item => item.title === this.$t('refund')),
            1,
          );
        }

        if (this.formData.details[0].quality_control === 0) {
          this.headers.splice(
            this.headers.findIndex(item => item.title === this.$t('Quality')),
            1,
          );
        }
      }

      await this.getTrackingNumber();

      this.loading = false;
    }
    await this.getUser();
  },
  methods: {
    async getTrackingNumber() {
      const orderIds = this.formData.details.map(detail => detail.order._id);

      if (orderIds.length === 0) return;

      try {
        const {
          content: { results: shippings = [] } = {},
        } = await this.$server.search('shippings', {
          ids: orderIds,
          limit: 300,
        });

        const shippingStatusMap = shippings.reduce(
          (map, { order, trackingNumber }) => {
            if (order && order._id && trackingNumber) {
              map[order._id] = trackingNumber;
            }
            return map;
          },
          {},
        );

        this.formData.details.forEach(detail => {
          if (shippingStatusMap[detail.order._id]) {
            detail.order.trackingNumber = shippingStatusMap[detail.order._id];
          }
        });
      } catch (error) {
        console.error('Error fetching tracking number:', error);
      }
    },
    RouterBack: function() {
      this.$router.back();
    },
    async getCurrency() {
      await this.$store.dispatch('wharhouse/getCurrency').then(res => {
        this.currency = res;
      });
    },

    generateReport() {
      const outputTypes = jsPDFInvoiceTemplate.OutputType;
      let data = [];
      this.loading = true;
      const globalFees = this.formData.details[0].global_vat || 0;
      let trackingnumber = this.formData.details[0].order.trackingNumber || 0;

      if (globalFees > 0 && globalFees !== undefined) {
        this.headers = this.headers.filter(
          header =>
            header.title !== this.$t('cancellation') &&
            header.title !== this.$t('shipping') &&
            header.title !== this.$t('fulfillement') &&
            header.title !== this.$t('Quality') &&
            header.title !== this.$t('confirmation'),
        );

        
      } else {
        this.headers = this.headers.filter(
          header => header.title !== this.$t('global fees'),
        );
      }

      this.headers.push({ title: this.$t('total') });


      
      this.formData.details.forEach(el => {
        let obj = [
          el.order.id,
          Math.sign(el.amount) == -1 ? 0 : el.order.totalPrice || 0,
        ];
        obj.push(trackingnumber);
        obj.push(el.order.customer.city);

        if (globalFees > 0) {
          obj.push(
            globalFees !== undefined && globalFees !== null
              ? globalFees.toString()
              : '0',
          ); // Global Fees
 
        } else {
          obj.push(
            el.shipping_vat !== undefined && el.shipping_vat !== null
              ? el.shipping_vat.toString()
              : '0',
          ); // Shipping Fee
          obj.push(
            el.fulfillement_fees_vat !== undefined &&
              el.fulfillement_fees_vat !== null
              ? el.fulfillement_fees_vat.toString()
              : '0',
          ); // Fulfillement Fee
          obj.push(
            el.quality_control !== undefined && el.quality_control !== null
              ? el.quality_control.toString()
              : '0',
          ); // Quality Fee
          obj.push(
            el.confirmation_vat !== undefined && el.confirmation_vat !== null
              ? el.confirmation_vat.toString()
              : '0',
          ); // Confirmation Fee
        }

        obj.push(
          el.amount !== undefined && el.amount !== null
            ? el.amount.toString()
            : '0',
        ); // Total
        data.push(obj);
      });

      const props = {
        outputType: OutputType.Save,
        returnJsPDFDocObject: true,
        fileName: 'Invoice ' + new Date().getFullYear(),
        orientationLandscape: false,
        logo: {
          src: this.image,
          width: 53.33,
          height: 26.66,
          margin: { top: 0, left: 0 },
        },
        business: {
          name: 'Invoice #: ' + this.formData.id,
          address:
            'Warehouse: ' +
            this.$f.getCountryNameByCode(this.options, this.formData.country),
          phone:
            'Payment Date: ' +
            this.$moment(this.formData.date).format('yyyy-MM-DD'),
          email: 'Store: ' + this.formData.seller.company,
          email_1: 'Seller: ' + this.formData.seller.fullName,
          website: 'Payment method: ' + this.formData.method,
        },
        invoice: {
          num: 19,
          headerBorder: false,
          tableBodyBorder: false,
          header: this.headers, // Updated header
          table: data, // Updated data
          additionalRows: [
            {
              col1: 'Total Sales:',
              col2:
                this.totalSales !== undefined && this.totalSales !== null
                  ? this.totalSales.toString()
                  : '0',
              col3: this.currency,
              style: { fontSize: 7 },
            },
            {
              col1: 'Total Fees:',
              col2: this.totalFees.toString(),
              col3: this.currency,
              style: { fontSize: 7 },
            },
            {
              col1: `TVA(${
                this.formData.tva ? this.formData.tva.toString() : '0'
              }%)`,
              col2:
                this.formData.vatFees !== undefined &&
                this.formData.vatFees !== null
                  ? this.formData.vatFees.toString()
                  : '0',
              col3: this.currency,
              style: { fontSize: 7 },
            },
            {
              col1: 'Payment net:',
              col2:
                this.total !== undefined && this.total !== null
                  ? this.total.toString()
                  : '0',
              col3: this.currency,
              style: { fontSize: 8 },
            },
          ],
        },
        pageEnable: true,
        pageLabel: 'Page ',
      };

      jsPDFInvoiceTemplate(props);
      this.loading = false;
    },

    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async getTotal(data) {
      this.total = 0;
      this.totalFees = 0;
      this.totalSales = 0;

      if (data.details && data.details.length) {
        this.totalSales = data.details
          .map(item => {
            if (item.global_vat > 0) {
              return item.amount + item.global_vat + item.confirmation_vat;
            } else {
              return (
                item.amount +
                item.confirmation_vat +
                item.fulfillement_fees_vat +
                item.shipping_vat +
                item.shipping_refund_vat +
                item.shipping_cancel_vat +
                item.quality_control
              );
            }
          })
          .flat()
          .reduce((acc, sum) => acc + sum, 0);

        this.totalFees = data.details
          .map(item => {
            if (item.global_vat > 0) {
              return item.global_vat + item.confirmation_vat;
            } else {
              return (
                item.confirmation_vat +
                item.fulfillement_fees_vat +
                item.shipping_vat +
                item.shipping_refund_vat +
                item.shipping_cancel_vat +
                item.quality_control
              );
            }
          })
          .flat()
          .reduce((acc, sum) => acc + sum, 0);

        this.total = data.details
          .map(item => item.amount)
          .reduce((prev, curr) => prev + curr, 0);

        this.total = this.total - data.vatFees;
        if (data.refunds && data.refunds.length) {
          this.total =
            this.total -
            data.refunds
              .map(item => item.fees)
              .reduce((prev, curr) => prev + curr, 0);
        }

        this.total =
          this.total -
          data.expeditions
            .map(item => parseFloat(item.fees) + parseFloat(item.packageFees))
            .reduce((prev, curr) => prev + curr, 0);
      }
    },
  },
};
</script>

<style>
.empty-row {
  background: repeating-linear-gradient(
    53deg,
    #bfc0c2 4%,
    #fcfcff 11px 6%,
    #ffffff 10px 7%,
    #9d9c9c 15px
  );
}

/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>
